import React from 'react';

import arEG from 'antd/es/locale/ar_EG';
import heIL from 'antd/es/locale/he_IL';
import enGB from 'antd/es/locale/en_GB';


const supportedLanguages = [
    {
        key: 'en',
        nativeName: 'English'
    },
    {
        key: 'he',
        nativeName: 'עברית',
    },
    {
        key: 'ar',
        nativeName: 'العربية'
    }
]

const languageDirections = {
    en : 'ltr',
    he : 'rtl',
    ar : 'rtl'
}

const dictionary = {
    "Results" : {
        "he" : "תוצאות",
        "ar" : "النتائج"
    },
    "Welcome to the Center for the Study of the US search engine" : {
        "he" : 'ברוכים הבאים למנוע החיפוש של המרכז לחקר ארה"ב',
        "ar" : 'مرحبًا بكم في محرك البحث للمركز لدراسة الولايات المتحدة'
    },
    "Searches" : {
        "he" : "חיפושים",
        "ar" : "بحث"
    },
    "Title" : {
        "he" : "כותר",
        "ar" : "عنوان",
    },
    "Contributor" : {
        "he" : "מחבר",
        "ar" : "مؤلف"
    },
    "Language" : {
        "he" : "שפה",
        "ar" : "لغة"
    },
    "Date" : {
        "he" : "תאריך",
        "ar" : "تاريخ"
    },
    "Description" : {
        "he" : "תיאור",
        "ar" : "وصف"
    },
    "Library of Congress" : {
        "he" : "ספרית הקונגרס",
        "ar" : "مكتبة الكونغرس"
    },
    "UC Berkeley libraries (OskiCat)" : {
        "he" : "ספריות אוניברסיטת ברקלי",
        "ar" : "مكتبات جامعة بركلي"
    },
    "Stanford University" : {
        "he" : "אוניברסיטת סטנפורד",
        "ar" : "جامعة ستانفورد"
    },
    "Princeton University" : {
        "he" : "אוניברסיטת פרינסטון",
        "ar" : "جامعة برينستون"
    },
    "Unified catalog of California Archives" : {
        "he" : "קטלוג מאוחד של ארכיוני קליפורניה",
        "ar" : "كتالوج موحد لأرشيف كاليفورنيا"
    },
    "Huntigton library digital collection" : {
        "he" : "האוסף הדיגיטלי של ספרית הנטיגטון",
        "ar" : "مكتبة هنتنغتون الرقمية"
    },
    "Tel Aviv University libraries (Daata)" : {
        "he" : 'ספריות אוניברסיטת תל-אביב (דעת"א)',
        "ar" : "مكتبات جامعة تل أبيب"
    },
    "Unified Israeli libraries catalog (ULI)" : {
        "he" : "קטלוג מאוחד ישראלי",
        "ar" : "الكتالوج الموحد الإسرائيلي"
    },
    "(no search yet)" : {
        "he" : "(אין חיפושים)",
        "ar" : "(لم يتم البحث)"
    },
    "(Encountered error while searching)" : {
        "he" : "(שגיאה התרחשה במהלך החיפוש)",
        "ar" : "(حدث خطأ أثناء البحث)",
    },
    "(search ongoing)" : {
        "he" : "(מחפש...)",
        "ar" : "(البحث مستمر)",
    },
    "results" : {
        "he" : "תוצאות",
        "ar" : "نتائج",
    },
    "input search text" : {
        "he" : "קלט לחיפוש",
        "ar" : "مدخلات للبحث"
    },
    "Translate input to English" : {
        "he" : "תרגם לאנגלית",
        "ar" : "ترجمة إلى الإنجليزية"
    },
    "Possible Translations:" : {
        "he" : "תרגומים אפשריים:",
        "ar" : "الترجمات المحتملة:"
    },
    "Provide your own translation:" : {
        "he" : "הצע תרגום:",
        "ar" : "قدم ترجمتك الخاصة:",
    },
    "No translation found. Please provide your own translation:" : {
        "he" : "לא נמצא תרגום. אנא הצע תרגום",
        "ar" : "لم يتم العثور على ترجمة ، يرجى تقديم ترجمتك"
    },
    "Clear search" : {
        "he" : "נקה חיפוש",
        "ar" : "مسح البحث"
    },
    "Search" : {
        "he" : "חפש",
        "ar" : "ابحث"
    },
    'Head to the "Searches" panel on the left in order to initiate a new search' : {
        "he" : 'פנה לחלונית החיפושים מימין כדי להתחיל חיפוש חדש',
        "ar" : 'توجه إلى لوحة "عمليات البحث" على اليمين لبدء بحث جديد'
    },
    "Translating" : {
        "he" : 'מתרגם',
        "ar" : 'يترجم',
    }, 
    "Searching" : {
        "he" : "מחפש",
        "ar" : "يبحث"
    },
    "Error when translating input. Try running without translation" : {
        "he" : ".אירעה שגיאה במהלך התרגום. נסי לחפש ללא תרגום",
        "ar" : "حدث خطأ عند الترجمة. حاولي البحث دون ترجمة"
    },
    "Encountered error during search" : {
        "he" : "אירעה שגיאה במהלך החיפוש",
        "ar" : "حدث خطأ أثناء البحث"
    },
    "Error during translation" : {
        "he" : "אירעה שגיאה במהלך התרגום",
        "ar" : "حدث خطأ عند الترجمة"
    },
    "Error during run" : {
        "he" : "אירעה שגיאה במהלך החיפוש",
        "ar" : "حدث خطأ عند البحث"
    },
    "Error during search" : {
        "he" : "אירעה שגיאה במהלך החיפוש",
        "ar" : "حدث خطأ عند البحث"
    },
    "No value was given to search" : {
        "he" : "לא ניתן ערך לחיפוש",
        "ar" : "قيمة غير قابلة للبحث"
    },
    "Israeli libraries" : {
        "he" : "ספריות בישראל",
        "ar" : "مكتبات إسرائيلية"
    },
    "Online material from worlwide libraries" : {
        "he" : "חומר דיגיטלי מספריות ברחבי העולם",
        "ar" : "مواد رقمية من المكتبات في جميع أنحاء العالم"
    },
    "Archives" : {
        "he" : "ארכיונים",
        "ar" : "أرشيفات"
    },
    "OK" : {
        "he" : "אישור",
        "ar" : "حسنا"
    },
    "Cancel" : {
        "he" : "ביטול",
        "ar" : "إلغاء"
    },
    "Access item" : {
        "he" : "פתח רשומה",
        "ar" : "افتح سجل"
    },
    "See results" : {
        "he" : "להצגת התוצאות הקש",
        "ar" : "لعرض النتائج اضغط هنا"
    },
    "here" : {
        "he" : "כאן",
        "ar" : "هنا"
    },
    "JSTOR" : {
        "he" : "JSTOR",
        "ar" : "JSTOR"
     },
     "Google Scholar" : {
         "he" : "Google Scholar",
         "ar" : "Google Scholar"
     },
     "Article Repositories" : {
         "he" : "מאגרי מאמרים",
         "ar" : "مستودعات المادة"
     },
    "Social Science Databases" : {
        "he" : "מאגרי נתונים של מדעי החברה ויחב\"ל",
        "ar" : "قواعد بيانات العلوم الاجتماعية والعلاقات الدوليةمستودعات المادة"
    },
    "NORC General Society Survey" : {
        "he" : "NORC General Society Survey",
        "ar" : "NORC General Society Survey"
    },
    "US Census" : {
        "he" : "הצנזוס של ארה\"ב",
        "ar" : "تعداد الولايات المتحدة"
    },
    "Pew Reaserch Center" : {
        "he" : "מכון המחקר פיו",
        "ar" : "مركز بيو للأبحاث"
    },
    "Yale's avalon project (historical documents in law, history and diplomacy)" :{
        "he" : "פרוייקט 'אבלון' של אונ' ייל (מסמכים הסטוריים במשפטים ודיפולמטיה)",
        "ar" : "مشروع يالون أفالون (وثائق تاريخية في القانون والتاريخ والدبلوماسية)"
    },
     "The search engine is designed to help find material - books, sources etc. - on any subject related to the U.S." : {
         "he" : "מנוע החיפוש נועד לעזור למצוא חומרים - ספרים, מקורות וכו' - בכל נושא הקשור לארצות הברית",
         "ar" : "تم تصميم محرك البحث للمساعدة في العثور على مواد - كتب ، مصادر ، إلخ - حول أي موضوع متعلق بالولايات المتحدة"
     },
     "Accessibility" : {
         "he" : "נגישות",
         "ar" : "إمكانية الوصول"
     },
     "Accessibility Statement" : {
        "he" : "הצהרת נגישות",
        "ar" : "بيان إمكانية الوصول"
     },
     "Do you want to deactivate accessibility mode?" : {
         "he" : "האם את/ה מעוניינ/ת לצאת ממצב נגישות?",
         "ar" : "هل تريد الخروج من وضع إمكانية الوصول؟"
     },
     "Do you want to activate accessibility mode?" : {
        "he" : "האם את/ה מעוניינ/ת לעבור למצב נגישות?",
        "ar" : "هل تريد تفعيل وضع إمكانية الوصول؟"
    },
    "Go to results view" : {
        "he" : "למסך התוצאות הראשי",
        "ar" : "إلى شاشة النتائج الرئيسية"
    },
    "Go to new search" : {
        "he" : "לחיפוש חדש",
        "ar" : "للبحث الجديد"
    },
    "All types" : {
        "he" : "כל סוגי החומרים",
        'ar' : 'كل الانواع'
    },
    "Audio": {
        "he" : "קבצי אודיו",
        'ar' : 'ملفات صوتية'
    },
    "Books": {
        "he" : "ספרים",
        'ar' : 'كتب'
    },
    "Images": {
        "he" : "תמונות",
        'ar' : 'صور'
    },
    "Legislation / Government publications": {
        "he" : "חקיקה / פרסומים ממשלתיים",
        'ar' : 'تشريعات / مطبوعات حكومية'
    },
    "Manuscripts": {
        "he" : "כתבי יד",
        'ar' : 'مخطوطات'
    },
    "Maps": {
        "he" : "מפות",
        'ar' : 'خرائط'
    },
    "Notated music" : {
        "he" : "תוים",
        'ar' : 'نوتات موسيقية'
    },
    "Newspapers" : {
        "he" : "עיתונים",
        'ar' : 'صحف'
    },
    "Periodicals" : {
        "he" : "כתבי-עת",
        'ar' : 'دوريات'
    },
    "Personal narratives" : {
        "he" : "עדויות אישיות",
        'ar' : 'روايات شخصية'
    },
    "Software" : {
        'he' : 'תוכנה',
        'ar' : 'برمجيات'
    },
    "Web pages" : {
        'he' : 'עמוד אינטרנט',
        'ar' : 'صفحة على الإنترنت'
    },
    "Video" : {
        'he' : 'וידיאו',
        'ar' : 'فيديو'
    },
    "Archived websites" : {
        'he' : 'אתרי אינטרנט מאורכבים',
        'ar' : 'المواقع المؤرشفة'
    },
    "Datasets" : {
        'he' : 'מקבצי נתונים',
        'ar' : 'مجموعات البيانات'
    },
    'Dissertations' : {
        'he' : 'תזות',
        'ar' : 'أطروحات'
    },
    "unsupported filter" : {
        'he' : 'סינון זה אינו נתמך',
        'ar' : 'مرشح غير مدعوم'
    },
    "Source does not support filter by more than one filter type" : {
        'he' : 'מקור זה לא תומך בסינון על בסיס יותר מסוג אחד',
        'ar' : 'المصدر لا يدعم التصفية بأكثر من نوع مرشح'
    },
    "Source does not support filter by dates" : {
        'he' : 'מקור זה לא תומך בסינון על בסיס תאריכים',
        'ar' : 'المصدر لا يدعم التصفية المستندة إلى التاريخ'
    },
    "Material type" : {
        'he' : 'סוג החומר',
        'ar' : 'نوع المادة'
    },
    
    "Filters" : {
        'he' : 'מסננים',
        'ar' : 'المرشحات'
    }

 
}

const accessibilityStatement = store => {
    switch(store.state.language) {
        case "en" :
            return (
                <div>
                <p>
                As the developer of this website I place great importance on making it websites accessible to the general public, and has invested great efforts in achieving this goal. I therefore try to ensure that the site meets the standard accepted in Israel and that it is accessible to people with disabilities.
                </p>
                <p>
                    The site was examined according to the accessibility guidelines in the Israeli Standard 5568 - guidelines for accessibility of content on the Internet at AA level. This Israeli provision is identical to the guidelines of the International Organization for Standardization on the Web: Web Content Accessibility Guidelines (WCAG) 2.0.
                </p>
                <p>
                    The following tests where conducted:
                    <ul>
                        <li>
                        Accessibility adjustments were carried out according to the recommendations of the Israeli standard (5568) for access to content on the Internet at the AA level, and according to the international guidelines (WCAG2.0)
                        </li>
                        <li>
                        The tests were conducted for highest compatibility with multiple browsers
                        </li>
                        <li>
                        The site supports for the standard keyboard usage pattern with the arrow keys, the Enter and Esc buttons to exit menus and windows
                        </li>
                        <li>
                        The site is optimized for display in popular browsers as mentioned above
                        </li>
                        <li>
                        The accessibility tests were carried out using a screen reader - Jaws
                        </li>
                    </ul>
                </p>
                <p>
                    It is important to note that despite our many efforts to make all pages accessible, parts of the site may still not be accessible.
                </p>
                <p>
                    If you have difficulty accessing the site and you’d like to let me know about the lack of accessibility adjustments, request such adjustments or if you wish to draw my attention to any issue on the topic, you can contact me at: orrappelkriyzer.CSUS at gmail.com.
                </p>
                </div>
            );
        case "he" :
            return  (
                <div>
                <p>
                כמפתח אתר זה, אני רואה חשיבות רבה בהנגשתו לציבור הרחב, והשקעתי מאמצים רבים על מנת להשיג מטרה זו. במסגרת זו אני משתדל לוודא שהוא יעמוד בתקן המקובל בישראל ויהיה נגיש לאנשים עם מוגבלויות.  
                </p>
                <p>
                    האתר נבדק בהתאם להנחיות הנגישות בתקן הישראלי 5568 - קווים מנחים לנגישות תכנים באינטרנט לרמה AA . תקן ישראלי זה זהה למסמך הקווים המנחים של הארגון הבינלאומי העוסק בתקינה ברשת: Web Content Accessibility Guidelines (WCAG) 2.0.
                </p>
                <p>
                    בין השאר, נערכו הבדיקות הבאות:
                    <ul>
                        <li>
                        התאמות הנגישות בוצעו על-פי המלצות התקן הישראלי (ת"י 5568) לנגישות תכנים באינטרנט ברמת AA ועל-פי מסמך WCAG2.0 הבינלאומי
                        </li>
                        <li>
                        הבדיקות נבחנו לתאימות הגבוהה ביותר עבור מספר דפדפנים
                        </li>
                        <li>
                        האתר תומך בדפוס השימוש המקובל להפעלה עם מקלדת בעזרת מקשי החיצים, Enter ו- Esc ליציאה מתפריטים ומחלונות
                        </li>
                        <li>
                        האתר מותאם לתצוגה בדפדפנים הנפוצים כאמור לעיל
                        </li>
                        <li>
                        בדיקות הנגישות בוצעו באמצעות קרא מסך  - Jaws
                        </li>
                    </ul>
                </p>
                <p>
                חשוב לציין כי למרות מאמצי הרבים להנגיש את האתר, יתכן ויתגלו חלקים באתר שעדיין אינם נגישים.                
                </p>     
                <p>
                אם נתקלת בקושי לגלוש באתר, אם תרצה להודיע על היעדר התאמות נגישות, לבקש ביצוע הנגשה או אם תרצה להפנות את תשומת לבנו לנושא כלשהו בתחום, באפשרותך לפנות אלי לכתובת: orrappelkroyzer.CSUS at gmail.com
                </p>
                </div>
            );
        case "ar" : 
            return (
                <div>
                <p>
                كمطور لهذا الموقع ، أرى أهمية كبيرة في جعله في متناول الجمهور العام ، وقد بذلت الكثير من الجهود لتحقيق هذا الهدف. في هذا السياق ، أسعى إلى التأكد من أنه يفي بالمعايير في إسرائيل ويمكن للأشخاص ذوي الإعاقة الوصول إليه.
                </p>
                <p>
                تم اختبار الموقع وفقًا لمعيار إمكانية الوصول 5568 - إرشادات إمكانية الوصول إلى الإنترنت للمستوى AA. هذا المعيار الإسرائيلي مماثل لإرشادات المنظمة الدولية لتنظيم الشبكات: Web Content Accessibility Guidelines (WCAG) 2.0
                </p>
                <p>
                    من بين أمور أخرى ، أجريت الاختبارات التالية:
                    <ul>
                        <li>
                        تم إجراء تعديلات على إمكانية الوصول وفقًا لتوصيات المعيار الإسرائيلي (TA 5568) لإمكانية الوصول إلى الإنترنت على مستوى AA ووفقًا لوثيقة WCAG2.0 الدولية                        
                        </li>
                        <li>
                        تم اختبار الاختبارات لأعلى توافق لعدة متصفحات
                        </li>
                        <li>
                        دعم الموقع نمط استخدام لوحة المفاتيح القابلة للتخصيص مع مفاتيح الأسهم ، Enter و Esc للخروج من القوائم والإطارات
                        </li>
                        <li>
                        تم تحسين الموقع لعرضه في المتصفحات الشائعة كما هو مذكور أعلاه
                        </li>
                        <li>
                        تم إجراء اختبار إمكانية الوصول باستخدام قارئ الشاشة  - Jaws
                        </li>
                    </ul>
                </p>
                <p>
                من المهم ملاحظة أنه على الرغم من الجهود العديدة المبذولة لجعل الموقع متاحًا ، إلا أن أقسام الموقع ربما لا تزال غير متوفرة.
                </p>     
                <p>
                إذا كنت تواجه صعوبة في تصفح الموقع ، أو إذا كنت ترغب في الإعلان عن عدم وجود أماكن إقامة يمكن الوصول إليها أو طلب إمكانية الوصول أو إذا كنت ترغب في توجيه انتباهنا إلى أي موضوع في هذا المجال ، يمكنك الاتصال بي على العنوان التالي: orrappelkroyzer.CSUS at gmail.com
                </p>
                </div>
            );

        default:
            throw new Error("Unknown kanguage " + store.state.language);
    }

}

const antdConfigs = {
    en : enGB,
    he : heIL,
    ar : arEG
}

const translateText = (store, text) => {
    try {
        return (
        store.state.language === 'en' ? text : 
        dictionary[text][store.state.language]);
    } 
    catch(err) {
        console.log("Error translating " + text)
        throw(err)
    }
}

const getDirection = (store) => (
    languageDirections[store.state.language]
)

const getFirstSide = (store) => (getDirection(store) === 'rtl' ? "right" : "left");

const getLastSide = (store) => (getDirection(store) === 'rtl' ? "left" : "right"); 

const getAntdConfig = (store) => (
    antdConfigs[store.state.language]
)

export {supportedLanguages, getDirection, translateText, getAntdConfig, accessibilityStatement, getFirstSide, getLastSide}
